import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ExternalPageComponent } from './external-page.component';
import { HeaderPageModule } from '../header-page/header-page.module';
import { MatIconModule } from '@angular/material/icon';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatButtonModule } from '@angular/material/button';
import { LoadingModule } from 'projects/component-library/src/public-api';

@NgModule({
  declarations: [
    ExternalPageComponent
  ],
  imports: [
    CommonModule,
    HeaderPageModule,
    FlexLayoutModule,
    MatIconModule,
    MatButtonModule,
    LoadingModule
  ],
  exports: [
    ExternalPageComponent
  ]
})
export class ExternalPageModule { }
